import { useEffect, useState } from "react";
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { getAnswersByBlockAndUser, getAnswersByBlockAndUserTIM } from "../axios/axiosFunctions";

// Admin responses view: lists each question in a block and the exact answer the
// member selected (no chart). Reuses the same per-block/user endpoints as the
// profile report — group-aware when a groupId is provided (TIM-family teams).
const ANSWER_LABELS = {
  very: "Very Confident",
  confident: "Confident",
  somewhat: "Somewhat Confident",
  notConfident: "Not Confident",
  unable: "Unable to Respond",
};

const labelFor = (answer) => ANSWER_LABELS[answer] || answer || "—";

const BlockResponsesList = ({ blockId, userId, groupId, questionLength }) => {
  const [rows, setRows] = useState([]);
  const [reflection, setReflection] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const load = async () => {
      const res = groupId
        ? await getAnswersByBlockAndUserTIM(blockId, userId, groupId)
        : await getAnswersByBlockAndUser(blockId, userId);
      const answers = [...(res?.answers || [])];
      // An extra answer beyond the rated questions is the open-ended reflection.
      if (answers.length > questionLength) {
        const refl = answers.pop();
        setReflection(refl?.answer || "");
      } else {
        setReflection("");
      }
      setRows(answers.map((a) => ({ question: a.question?.text || "", answer: a.answer })));
      setLoaded(true);
    };
    load();
  }, [blockId, userId, groupId, questionLength]);

  if (loaded && rows.length === 0 && !reflection) {
    return (
      <Box sx={{ px: { xs: 2, md: 6 }, py: 2 }}>
        <Typography variant="body1" color="text.secondary">No responses recorded for this section.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ px: { xs: 2, md: 6 }, py: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 700, width: "70%" }}>Question</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Response</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((r, i) => (
            <TableRow key={i}>
              <TableCell sx={{ verticalAlign: "top", color: "#33475b" }}>{r.question}</TableCell>
              <TableCell sx={{ verticalAlign: "top", fontWeight: 600, whiteSpace: "nowrap" }}>{labelFor(r.answer)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {reflection && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#33475b" }}>
            What stands out as a priority focus area in this section?
          </Typography>
          <Typography variant="body1" sx={{ mt: 0.5, whiteSpace: "pre-wrap" }}>{reflection}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default BlockResponsesList;
